import React, { useState } from 'react';
import PersonnelTransferModal from './PersonnelTransferModal';
import { Button } from '../ui-kit';
import { IconArrowRight } from '../ui-kit/icons.js';

const StartButton = ({ userId, groupIds, schedulableGroupIds }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Button variant="secondary" onClick={handleShow} size="sm">
        <IconArrowRight /> {I18n.t('schedules.exchanges.personnel_transfer.button_title')}
      </Button>
      {show && (
        <PersonnelTransferModal
          onHide={handleClose}
          userId={userId}
          groupIds={groupIds}
          schedulableGroupIds={schedulableGroupIds}
        />
      )}
    </>
  );
};

export default StartButton;
